var React = require('react');

function DangerIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 8.96V3.29h1v5.67h-1z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M8 12.5a1 1 0 110-2 1 1 0 010 2z","fill":"currentColor","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 1a7 7 0 100 14A7 7 0 008 1zM0 8a8 8 0 1116 0A8 8 0 010 8z","fill":"currentColor","key":2})]);
}

DangerIconInline.defaultProps = {"viewBox":"0 0 16 16","fill":"none","preserveAspectRatio":"xMidYMid meet","style":{"color":"rgb(185, 94, 4)","height":"20px","verticalAlign":"middle","width":"20px"}};

module.exports = DangerIconInline;

DangerIconInline.default = DangerIconInline;
